import React from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'

const months = [
  // {"text": "تمام ماه ها", "value": 0, "key": 0},
  {"text": "فروردین", "value": 1, "key": 1},
  {"text": "اردیبهشت", "value": 2, "key": 2},
  {"text": "خرداد", "value": 3, "key": 3},
  {"text": "تیر", "value": 4, "key": 4},
  {"text": "مرداد", "value": 5, "key": 5},
  {"text": "شهریور", "value": 6, "key": 6},
  {"text": "مهر", "value": 7, "key": 7},
  {"text": "آبان", "value": 8, "key": 8},
  {"text": "آذر", "value": 9, "key": 9},
  {"text": "دی", "value": 10, "key": 10},
  {"text": "بهمن", "value": 11, "key": 11},
  {"text": "اسفند", "value": 12, "key": 12}
]

class MonthSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: months,
      selected: '',
      loading: false,
      defaultValue: this.props.defaultValue,
    };

  }

  // componentWillMount() {
  //   this.getData()
  // }

  // async getData() {

  //   this.setState({ loading: true })

  //   await travelBrandsService.getAll()
  //     .then((res) => {
  //       let arr = res.data;
  //       // console.log(arr);
  //       var items = [];
  //       for (var i = arr.length; i--;) {
  //         var obj = arr[i];
  //         obj.key = obj.travelBrandId;
  //         obj.value = obj.travelBrandId;
  //         obj.text = obj.name;
  //         items.push(obj)
  //       }

  //       this.setState({ data: arr, loading: false });

  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false })
  //     });

  // };

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }
  }

  // shouldComponentUpdate(nextProps){
  //   return true;
  // }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selected: selected })
    this.props.onChange(selected)

  }



  render() {

    const { data, loading, defaultValue } = this.state;
    const { clearable, disabled } = this.props;

    return (
      <Dropdown
        placeholder='ماه'
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className="semantic-select-box"
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedMonthSelect = connect(mapStateToProps)(MonthSelect);
export { connectedMonthSelect as MonthSelect };